import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';

import CSIO_coll_icon from '../../../assets/images/CSIO_coll_icon.png';
import CSIO_90 from '../../../assets/images/CSIO_90.png';
import CSIO_91 from '../../../assets/images/CSIO_91.png';
import CSIO_85 from '../../../assets/images/CSIO_85.png';

const ClDataStandardsGraphics = ({ width }) => (

  <Container>
    <Row>
      <Col sm={12} md={6} style={{marginTop: 60}}>
        <ClDataStandards />
      </Col>
      <Col sm={12} md={6}  style={{borderLeft: width > 768 ? '1px solid #899D75' : 'none', marginTop: 60}}>
        <NewBusinesses />
      </Col>
      <Col sm={12} md={6}  style={{marginTop: 60}}>
        <Brokers />
      </Col>
      <Col sm={12} md={6} style={{borderLeft: width > 768 ? '1px solid #899D75' : 'none', marginTop: 60}}>
        <BrokersExpect/>
      </Col>
    </Row>
  </Container>
)

const ClDataStandards = () => (
  <Col>
    <Row>
      <Col xs={4}>
        <img
          src={CSIO_90}
          style={{
            width: '100%',
            height: 'auto'
          }}
          aria-label="90%"
        />
      </Col>
      <Col xs={8}>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          paddingLeft: 20,
          paddingRight: 20,
          lineHeight: 1.2,
        }}>of
        <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> members reported </span>that<span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> CL Data Standards are </span>important or<span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> very important </span>
        </p>
      </Col>
    </Row>
  </Col>
)

const Brokers = () => (
  <Col>
    <Row>
      <Col xs={4}>
        <img
          src={CSIO_91}
          style={{
            width: '100%',
            height: 'auto'
          }}
          aria-label="91%"
        />
      </Col>
      <Col xs={8}>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          paddingLeft: 20,
          paddingRight: 20,
          lineHeight: 1.2,
        }}>of
        <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> brokers </span>are<span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> more likely to work with insurers </span>who implemented<span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> data standards </span>
        </p>
      </Col>
    </Row>
  </Col>
)

const BrokersExpect = () => (
  <Col>
    <Row>
      <Col xs={4}>
        <img
          src={CSIO_85}
          style={{
            width: '100%',
            height: 'auto'
          }}
          aria-label="85%"
        />
      </Col>
      <Col xs={8}>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          paddingLeft: 20,
          paddingRight: 20,
          lineHeight: 1.2,
        }}>of
        <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> brokers expect CL Data Standards </span>will mean faster and more accurate quotes,<span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}> improving the customer experience </span>
        </p>
      </Col>
    </Row>
  </Col>
)

const NewBusinesses = () => (
  <Col>
    <Row>
      <Col xs={4}>
        <img
          src={CSIO_coll_icon}
          style={{
            width: '100%',
            height: 'auto'
          }}
          alt=""
        />
      </Col>
      <Col xs={8}>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          paddingLeft: 20,
          paddingRight: 20,
          lineHeight: 1.2,
        }}>
          <span style={{fontSize: 26, fontWeight: 'bold', color: '#14183A'}}>2</span> new business segment questions completed:
          <ul>
            <li style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}>
            Retail
            </li>
            <li style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}>
            Business and professional services
            </li>
          </ul>
        </p>
      </Col>
    </Row>
  </Col>
)

export default ClDataStandardsGraphics;
